import {
  BRANCH_CONFIG_LIST,
  DOC_LIST,
  FETCH_BRANCH_CONFIG,
  FETCH_GLOBAL_CONFIG,
  FETCH_PARALLEL_WORKFLOWS,
  FETCH_PRODUCT_CATEGORY_CONFIG,
  FETCH_PRODUCT_CONFIG,
  PRODUCT_LIST,
  STAGES,
  UPDATE_BRANCH_CONFIG,
  UPDATE_GLOBAL_CONFIG,
  UPDATE_PRODUCT_CATEGORY_CONFIG,
  UPDATE_PRODUCT_CONFIG,
  BRANCH_CONFIG_LIST_BY_ID,
} from '../../resources/endPoint';

export const fetchGlobalConfigApi = data => {
  return {
    url: FETCH_GLOBAL_CONFIG,
    payload: data,
    method: 'get',
    tag: 'FETCH_GLOBAL_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const updateGlobalConfigApi = data => {
  return {
    url: UPDATE_GLOBAL_CONFIG,
    payload: data,
    method: 'post',
    tag: 'UPDATE_GLOBAL_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchBranchConfigApi = data => {
  return {
    url: FETCH_BRANCH_CONFIG,
    payload: data,
    method: 'post',
    tag: 'FETCH_BRANCH_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const updateBranchConfigApi = data => {
  return {
    url: UPDATE_BRANCH_CONFIG,
    payload: data,
    method: 'post',
    tag: 'UPDATE_BRANCH_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchProductCategoryConfigApi = data => {
  return {
    url: FETCH_PRODUCT_CATEGORY_CONFIG,
    payload: data,
    method: 'post',
    tag: 'FETCH_PRODUCT_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const fetchProductConfigApi = data => {
  return {
    url: FETCH_PRODUCT_CONFIG,
    payload: data,
    method: 'post',
    tag: 'FETCH_PRODUCT_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const updateProductConfigApi = data => {
  return {
    url: UPDATE_PRODUCT_CONFIG,
    payload: data,
    method: 'post',
    tag: 'UPDATE_PRODUCT_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const updateProductCategoryConfigApi = data => {
  return {
    url: UPDATE_PRODUCT_CATEGORY_CONFIG,
    payload: data,
    method: 'post',
    tag: 'UPDATE_PRODUCT_CATEGORY_CONFIG',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const productListApi = () => {
  return {
    url: PRODUCT_LIST,
    method: 'get',
    tag: 'PRODUCT_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchStages = (data) => {
  return {
    url: STAGES,
    payload: data,
    method: 'post',
    tag: STAGES,
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
  };
};
export const docListApi = data => {
  return {
    url: DOC_LIST,
    payload: data,
    method: 'post',
    tag: 'DOC_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};

export const branchConfigListApi = data => {
  return {
    url: BRANCH_CONFIG_LIST,
    payload: data,
    method: 'post',
    tag: 'BRANCH_CONFIG_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const branchConfigListByIdApi = data => {
  return {
    url: BRANCH_CONFIG_LIST_BY_ID,
    payload: data,
    method: 'post',
    tag: 'BRANCH_CONFIG_LIST_BY_ID',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
export const fetchParallelWorkflowsApi = data => {
  return {
    url: FETCH_PARALLEL_WORKFLOWS,
    payload: data,
    method: 'get',
    tag: 'FETCH_PARALLEL_WORKFLOWS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: '',
  };
};
